document.addEventListener( 'pageLoad', setCurrentPageStatusInNav );
function setCurrentPageStatusInNav() {
	const anchors = document.querySelectorAll( '#pulloutNav_menu .sub-menu a' );
	anchors.forEach( ( item ) => {
		item.parentNode.classList.remove( 'current_menu_item' );
		const url = new URL( item.href );
		if ( url.pathname === location.pathname ) {
			item.parentNode.classList.add( 'current_menu_item' );
		}
	} )
}